import Cookies from 'js-cookie'

const tokenKey = 'sampleLoginToken'

export default {
  getToken: () => {
    return Cookies.get(tokenKey)
  },
  setToken: (token) => {
    return Cookies.set(tokenKey, token)
  },
  removeToken: () => {
    return Cookies.remove(tokenKey)
  },

  set(key, value) {
    return Cookies.set(key, value)
  },
  get(key) {
    return Cookies.get(key)
  }
}



// WEBPACK FOOTER //
// ./src/common/cookie.js